// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".head-ai[data-v-257223b0]{-webkit-background-clip:text;background-clip:text;background-image:linear-gradient(90deg,#52aeff,#c930f7 51%,#e2283b);color:transparent}.doubleThead[data-v-257223b0]{display:none}.doubleThead.stickyThead[data-v-257223b0]{display:block;position:fixed;top:94px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
